import { Controller } from "@hotwired/stimulus"

export default class ComponentFeedbackController extends Controller {
  static targets = ["output", "live", "committed"]
  static values = { start: String, end: String, otpUrl: String }

  disconnect() {
    this.cancelOtpVerification()
  }

  destination({ detail: { value } }) {
    this.outputTarget.textContent = value
      ? `Selected destination: ${value.label} (${value.value}).`
      : "No destination selected."
  }
  categories({ detail: { selected } }) {
    this.outputTarget.textContent = selected.length
      ? `Selected categories: ${selected.join(", ")}.`
      : "No categories selected."
  }
  otpChanged() {
    this.cancelOtpVerification()
    this.outputTarget.textContent = "Enter all six digits. Use 123456 to verify the demo code."
  }
  otpCleared() {
    this.cancelOtpVerification()
    this.outputTarget.textContent = "Code cleared. Enter all six digits."
  }
  async otpComplete({ detail: { value } }) {
    this.cancelOtpVerification()
    const request = new AbortController()
    this.otpRequest = request
    this.outputTarget.textContent = "Verifying demo code…"
    try {
      const response = await fetch(this.otpUrlValue, {
        method: "POST",
        signal: request.signal,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
        },
        body: JSON.stringify({ code: value }),
      })
      if (!response.ok && response.status !== 422) throw new Error("Verification failed")
      const result = await response.json()
      if (!request.signal.aborted) this.outputTarget.textContent = result.message
    } catch (error) {
      if (!request.signal.aborted)
        this.outputTarget.textContent = "Unable to verify the demo code. Edit a digit to try again."
    } finally {
      if (this.otpRequest === request) this.otpRequest = null
    }
  }
  cancelOtpVerification() {
    this.otpRequest?.abort()
    this.otpRequest = null
  }
  quarter({ detail: { date } }) {
    this.outputTarget.textContent = `Selected reporting quarter: ${date.getFullYear()}-Q${Math.floor(date.getMonth() / 3) + 1}.`
  }
  availability({ detail: { date } }) {
    this.outputTarget.textContent = `${date.toLocaleDateString("en-US")}: ${(date.getDate() % 4) + 1} available slots.`
  }
  date({ detail: { date } }) {
    this.outputTarget.textContent = `Last accepted date: ${this.formatDate(date)}.`
  }
  range(event) {
    this[event.type.startsWith("start") ? "startValue" : "endValue"] = this.formatDate(event.detail.date)
    this.outputTarget.textContent = `Last accepted range: ${this.startValue || "none"} – ${this.endValue || "none"}.`
  }
  team({ detail: { value } }) {
    this.outputTarget.textContent = `${value.length} of 3 people selected.`
  }
  selectionLimit() {
    this.outputTarget.textContent = "Three people selected. Remove someone before adding another person."
  }
  budgetInput({ detail: { value } }) {
    this.liveTarget.textContent = value.map((amount) => `$${amount}`).join(" – ")
  }
  budgetChange({ detail: { value } }) {
    this.committedTarget.textContent = value.map((amount) => `$${amount}`).join(" – ")
  }
  formatDate(date) {
    return date ? date.toLocaleDateString("en-US") : "none"
  }
}
